import { Component } from '@angular/core';

@Component({
	selector: 'app-slide-from-right-container',
	imports: [],
	templateUrl: './slide-from-right-container.component.html',
	styleUrl: './slide-from-right-container.component.scss',
})
export class SlideFromRightContainerComponent {}
